/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CBCRemediationSpecByolCredentials { 
    /**
     * Carbon Black API Key ID
     */
    api_key_id?: string;
    /**
     * Carbon Black API Key Secret
     */
    api_key_secret?: string;
}

